module.exports = __webpack_public_path__ + "img/user09.ba0844a4.png";